require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/registrer/pdmainCartridgeRegistrer.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/registrer/pdmainCartridgeRegistrer.legacy.js
// module id = 722
// module chunks = 31